import fp from 'lodash/fp';
import { pageLayouts, pageSizes } from '../constants';
import { noCapMap } from '../utils';
import { reportHeader, table } from './partials';

const chartOffset = { x: 110, y: 0 };
const tableOffset = { x: -110, y: 60 };

const cpdActivityDetailsReport = ({
  pageLayout,
  pageSize,
  reportee,
  afsl,
  minDate,
  maxDate,
  progressPercentage,
  cpdActivity: {
    columns,
    rows
  },
  goals
}) => {
  const [
    typeHeader,
    cpdCategoryHeader,
    providerHeader,
    activityContentHeader,
    cpdPointsHeader,
    statusHeader,
    dateCompletedHeader,
    activitySourceHeader
  ] = columns;

  const goalColumns = fp.map(
    ({ goal }) => ({
      colSpan: .75,
      text: goal.name
    })
  )(goals)

  return [
    ...reportHeader({ report: 'Activity Report', reportee: `${reportee} Activity Details`, afsl, minDate, maxDate }),
    ['translate', fp.values(chartOffset)],
    ['translate', fp.values(tableOffset)],
    ...table({
      pageLayout,
      pageSize: pageSize || 'A4',
      remainingPageHeight: fp.get(
        `${pageSize || 'A4'}.${pageLayout === pageLayouts.landscape ? 'x' : 'y'}`
      )(pageSizes) - (chartOffset.y + tableOffset.y),
      reportHeader: [...reportHeader({ report: 'Activity Report', reportee: `${reportee} Activity Details`, afsl, minDate, maxDate }), ['translate', [0, tableOffset.y]],],
      headerRow: {
        colour: '#1fd1a1',
        text: {
          colour: '#fff'
        },
        columns: [
          {
            colSpan: .5,
            text: typeHeader
          },
          {
            colSpan: 2,
            text: cpdCategoryHeader
          },
          {
            colSpan: .75,
            text: providerHeader
          },
          {
            colSpan: 3,
            text: activityContentHeader
          },
          {
            colSpan: .75,
            text: cpdPointsHeader
          },
          {
            colSpan: .75,
            text: statusHeader
          },
          {
            colSpan: .75,
            text: dateCompletedHeader
          },
          {
            colSpan: 1,
            text: activitySourceHeader
          }
        ].concat(goalColumns)
      },
      rows: noCapMap((row, index) => {
        const [
          type,
          cpdCategory,
          provider,
          activityContent,
          cpdPoints,
          status,
          dateCompleted,
          activitySource,
          ...goalsData
        ] = row;

        return {
          colour: index % 2 === 0 ? '#fff' : '#EFEFEF',
          columns: [
            {
              colSpan: .5,
              text: type
            },
            {
              colSpan: 2,
              text: cpdCategory
            },
            {
              colSpan: .75,
              text: provider
            },
            {
              colSpan: 3,
              text: activityContent
            },
            {
              colSpan: .75,
              text: `${cpdPoints}`
            },
            {
              colSpan: .76,
              text: status
            },
            {
              colSpan: .75,
              text: dateCompleted
            },
            {
              colSpan: 1,
              text: activitySource
            },
          ].concat(
            fp.map(
              (data) => ({
                colSpan: .75,
                text: data
              })
            )(goalsData)
          )
        };
      })(rows)
    })
  ];
};

export default cpdActivityDetailsReport;



// WEBPACK FOOTER //
// ./src/reports/cpd-activity-details.js